import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ADD_BUTTON_COLUMN_WIDTH, EXTENDED_COLUMN_WIDTH, COLUMN_MARGIN } from "../../appointment-schedule.constants.js";
const ShowMoreButton = styled(Button, {
  shouldForwardProp: (props) => props !== "top"
})(
  ({ theme, top }) => `
  background: ${theme.palette.primary[800]}; // aqua mapped to primary
  position: absolute;
  right: 0;
  padding: 0;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  min-width: ${ADD_BUTTON_COLUMN_WIDTH}px;
  width: ${ADD_BUTTON_COLUMN_WIDTH}px;
  height: 16px;
  border-radius: 50%;
  color: ${theme.palette.common.white};
  top: ${top}%;
  z-index: 3;
  transform: translate(4px, -4px);
 `
);
const AppointmentGroupWrapper = styled("div", {})``;
const TimeDetails = styled("div", {
  shouldForwardProp: (props) => props !== "isExtended" && props !== "width" && props !== "isDayView"
})(
  ({ theme, width }) => `
  color: ${theme.palette.grey[400]};
  background: transparent;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  margin: 0;
  position: relative;
  border-right: 1px solid ${theme.palette.grey[300]};
  width: ${width ? `${width}%` : `${EXTENDED_COLUMN_WIDTH}px`};
`
);
const NonWorkingSlot = styled("div", {
  shouldForwardProp: (props) => props !== "top" && props !== "height"
})(
  ({ theme, top, height }) => `
  position: absolute;
  top: ${top ?? 0}%;
  left: 0;
  height: ${height ?? 0}%;
  background-image: linear-gradient(
    45deg,
    ${theme.palette.grey[300]} 25%,
    ${theme.palette.grey[100]} 25%,
    ${theme.palette.grey[100]} 50%,
    ${theme.palette.grey[300]} 50%,
    ${theme.palette.grey[300]} 75%,
    ${theme.palette.grey[100]} 75%,
    ${theme.palette.grey[100]} 100%
  );
  background-size: 15px 15px;
  color: ${theme.palette.grey[600]};
  width: calc(100% + ${ADD_BUTTON_COLUMN_WIDTH}px);
  padding: 4px;
  text-align: center;
  box-sizing: border-box;
  overflow: hidden;
`
);
const BlockerSlot = styled("div", {
  shouldForwardProp: (props) => props !== "top" && props !== "height"
})(
  ({ theme, top, height }) => `
  position: absolute;
  top: ${top ?? 0}%;
  left: 0;
  height: ${height ?? 0}%;
  background: ${theme.palette.error[500]};
  color: ${theme.palette.grey[600]};
  width: 100%;
  padding: 4px;
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 3;
`
);
const DetailsWrapper = styled("div")`
  width: calc(100% - ${ADD_BUTTON_COLUMN_WIDTH}px);
  position: relative;
`;
const OverbookedButtonsWrapper = styled("div")`
  width: ${ADD_BUTTON_COLUMN_WIDTH - COLUMN_MARGIN}px;
  position: relative;
  margin-left: ${COLUMN_MARGIN}px;
`;
export {
  AppointmentGroupWrapper,
  BlockerSlot,
  DetailsWrapper,
  NonWorkingSlot,
  OverbookedButtonsWrapper,
  ShowMoreButton,
  TimeDetails
};
